import PropTypes from "prop-types";
import "./ContentLeft.scss";

const ContentLeft = (props: any) => {
  return (
    <div className="first-section-content-left">
      <div className="text-area">
        <h1>{props.title}</h1>
        <div className="subtitle">{props.subtitle}</div>
      </div>
    </div>
  );
};

ContentLeft.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.element,
};

export default ContentLeft;
